var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPrevDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15679 3.21967C5.83072 2.92678 5.30205 2.92678 4.97598 3.21967L0.24456 7.46968C-0.0815202 7.76257 -0.0815202 8.23745 0.24456 8.53034L4.97598 12.7803C5.30205 13.0732 5.83072 13.0732 6.15679 12.7803C6.48286 12.4874 6.48286 12.0126 6.15679 11.7197L2.85076 8.75001H15.2656C15.7268 8.75001 16.1006 8.41422 16.1006 8.00001C16.1006 7.5858 15.7268 7.25001 15.2656 7.25001H2.85076L6.15679 4.28033C6.48286 3.98744 6.48286 3.51256 6.15679 3.21967Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrevDisabled);
export default __webpack_public_path__ + "static/media/ic-prev-disabled.015dc9168bfc6352124a691ff15860f2.svg";
export { ForwardRef as ReactComponent };